import React, { RefObject, useState } from "react"
import { NodeProps, Node } from "@xyflow/react"
import { Box, Heading, HStack, Icon, IconButton, Button } from "@chakra-ui/react"
import { FaChartLine } from "react-icons/fa6"
import Dialog from "@hydrologiq/shared/chakra/Dialog"
import InstallationMonitoringView from "@hydrologiq/shared/installation/InstallationMonitoringView"
import { NodeType } from "@hydrologiq/systems/types/SystemView"

interface InstallationGroupData {
  [key: string]: unknown
  installationId: string
  installationName: string
  container?: RefObject<HTMLElement | null>
  nodeType?: NodeType
  label: string
  id: string
  startDate: string
  endDate?: string
}
type InstallationNode = Node<InstallationGroupData, "installation">
interface InstallationGroupNodeProps extends NodeProps<InstallationNode> {}

// type InstallationGroup = Node<InstallationGroupData, "installationGroup">

const InstallationGroup: React.FC<InstallationGroupNodeProps> = ({ data, ...props }) => {
  const [isMonitoringDialogOpen, setIsMonitoringDialogOpen] = useState(false)

  const installationId = (data as any)?.installationId
  const installationName = (data as any)?.label || "Installation"

  const handleOpenMonitoring = () => {
    setIsMonitoringDialogOpen(true)
  }

  const handleCloseMonitoring = () => {
    setIsMonitoringDialogOpen(false)
  }

  return (
    <Box w="100%" h="100%" data-testid={data?.testId} data-installation-id={data?.installationId} {...props}>
      <HStack padding="3px" opacity={0.6} justifyContent="space-between" alignItems="center">
        <Heading size="sm" color="primary" truncate fontWeight="semibold">
          {installationName}
        </Heading>

        <IconButton
          aria-label="Open monitoring dashboard"
          size="sm"
          variant="ghost"
          colorScheme="blue"
          opacity={0.7}
          _hover={{ opacity: 1, bg: "blue.50" }}
          title="View monitoring dashboard"
          pointerEvents="all"
          onClick={handleOpenMonitoring}
        >
          <Icon as={FaChartLine} />
        </IconButton>
      </HStack>

      {/* Full Screen Monitoring Dialog */}
      <Dialog
        title={`${installationName}`}
        loading={false}
        disabled={false}
        container={data?.container}
        open={isMonitoringDialogOpen}
        setOpen={setIsMonitoringDialogOpen}
        fullscreen={true}
        footer={undefined}
      >
        <Box w="100%" minW="800px">
          <InstallationMonitoringView
            installation={installationId}
            installationStartDate={data?.startDate}
            installationEndDate={data?.endDate}
          />
        </Box>
      </Dialog>
    </Box>
  )
}

export default InstallationGroup
